import { gradientColor } from '@/echartOption/common';

const color = [
  '#a759ff',
  '#ff9747',
  '#6b8aff',
  '#04d7ff',
  '#34abff',
  '#59c4e6',
  '#7d82d6',
  '#20edd2'
];

// function setData(options, data) {
//   options.data = data;
//   return options;
// }

export function makeDoughnut(options) {
  options = options || {
    color,
    tooltip: {
      trigger: 'item'
    },
    legend: {
      bottom: 10,
      left: 'center',
      // formatter: '{a} ({d}%)',
      textStyle: {
        color: '#d1d5d8'
      }
    },
    dataset: {
      source: [],
      dimensions: []
    },
    series: [
      {
        // name: '报警类型',
        type: 'pie',
        radius: ['20%', '50%'],
        center: ['50%', '40%'],
        startAngle: 180,
        itemStyle: {
          borderRadius: 5,
          borderColor: '#fff',
          borderWidth: 1
        },
        label: {
          formatter: '{b}\n{d}%'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '14',
            fontWeight: 'bold'
          }
        }
      }
    ]
  };
  return options;
}

export function makeLine(options) {
  const _color = (options && options.color) || color;

  return {
    color: _color,
    tooltip: {
      trigger: 'axis',
      show: true
    },
    grid: {
      left: '5%',
      right: '5%',
      bottom: '3%',
      top: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      splitLine: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: '#04d7ff'
        }
      }
    },
    yAxis: {
      type: 'value',
      min: 0,
      max(v) {
        return Math.ceil((v.max * 1.2) / 10) * 10;
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#283763'
        }
      },
      axisLine: {
        lineStyle: {
          color: '#04d7ff'
        }
      }
    },
    dataset: {
      source: [],
      dimensions: []
    },
    series: [
      {
        type: 'line',
        showSymbol: false,
        areaStyle: { color: gradientColor(_color[0]) }
      }
    ]
  };
}

export function makeBar(options) {
  const { xLabelRotate } = options || { xLabelRotate: 20 };
  const _color = (options && options.color) || color;

  return {
    color: _color,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    grid: {
      left: '3%',
      right: '5%',
      bottom: '3%',
      top: '10%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          interval: 0,
          rotate: xLabelRotate
        },
        axisLine: {
          lineStyle: {
            color: '#04d7ff'
          }
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        min: 0,
        max(v) {
          return Math.ceil((v.max * 1.2) / 100) * 100;
        },
        axisLine: {
          lineStyle: {
            color: '#04d7ff'
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#283763'
          }
        }
      }
    ],
    dataset: {
      source: [],
      dimensions: []
    },
    series: [
      {
        name: '次数',
        type: 'bar',
        barWidth: '60%'
      }
    ]
  };
}

export function setData(op, data) {
  if (!data.dataList) return;
  op.dataset = {
    source: data.dataList,
    dimensions: data.dimensions
  };
}

export function gather(data, key) {
  return data.dataList.map(e => e[key]).reduce((t, cur) => t + cur);
}

export function autoScroll(selector, cb) {
  /** @type {Element} */
  const el = document.querySelector(selector);
  let num;
  let stop = false;
  let prev = performance.now();
  const callback = time => {
    const temp = time - prev;
    if (num) cancelAnimationFrame(num);
    if (stop) return;
    if (temp >= 33) {
      prev = time;
      el.scrollTop += 3;
      cb && cb();
    }
    exe();
  };

  function exe() {
    num = requestAnimationFrame(() => callback(performance.now()));
  }

  exe();

  return () => {
    stop = true;
  };
}
